import React, { useState } from 'react';
import axios from 'axios';
import './OutputButtonSection.css';
import { useAuth } from "../../context/AuthContext";
import Spinner from "../Spinner/Spinner";

const OutputButtonSection = ({ onReload }) => {
  const { token } = useAuth();
  const [loading, setLoading] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleDownload = async () => {
    setLoading(true);
    setShowMessage(true);
    setSuccess(false);

    const baseUrl = process.env.REACT_APP_BASE_URL_BE;
    const downloadUrl = `${baseUrl}/algorithm/download/excel`;
    try {
      const response = await axios.get(downloadUrl, {
        responseType: 'blob',
        timeout: 1000000,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'output.xlsx');
      document.body.appendChild(link);
      link.click();
      if (link.parentNode) link.parentNode.removeChild(link);
      setSuccess(true);

      // Gọi reload file history nếu có
      if (onReload) onReload();
    } catch (error) {
      console.error("Error downloading the file", error);
      alert("ダウンロード中にエラーが発生しました。");
      setSuccess(false);
      setShowMessage(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button className="nm-cursor-non-text output-button" onClick={handleDownload} disabled={loading}>
        エクセル出力
      </button>
      {loading && <div className="global-loading-overlay"></div>}
      {showMessage && (
        <div className="loading-overlay">
          <div className="loading-box">
            {loading ? (
              <>
                <Spinner />
                <p>処理中です。しばらくお待ちください...</p>
              </>
            ) : success ? (
              <p style={{ fontWeight: 300 }}>ファイルのダウンロードが完了しました！</p>
            ) : null}
            {!loading && (
              <button className="nm-cursor-non-text close-button" onClick={() => setShowMessage(false)}>
                閉じる
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default OutputButtonSection;